var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 336,
    viewBox: "0 0 512 336",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 256.276V9.103A8.829 8.829 0 0 1 8.828.275h379.586L0 256.276z",
    fill: "#73AF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 79.724v247.172a8.829 8.829 0 0 1-8.828 8.828H123.586L512 79.724z",
    fill: "#4173CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 84.702V9.103a8.829 8.829 0 0 0-8.828-8.828H383.139L0 251.298v75.598a8.829 8.829 0 0 0 8.828 8.828h120.033L512 84.702z",
    fill: "#FFE15A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512 53.047V9.103a8.829 8.829 0 0 0-8.828-8.828h-71.718L0 282.953v43.944a8.829 8.829 0 0 0 8.828 8.828h71.718L512 53.047z",
    fill: "#464655"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTz);
export default __webpack_public_path__ + "static/media/tz.976dcabc97b8ba00ed104fab95a1d75e.svg";
export { ForwardRef as ReactComponent };